import React from 'react';
import { Image, ImageModifier } from '../Image';
import Bem from '../../../lib/bemUtils/bem';
import { TopHeadlineImage, TopHeadlineImageSmall } from '../../../types/api/ImageType';
import { RESPONSIVE_TYPE } from '../Image/Responsive';

/**
 * Special case for Topheadlines.
 *
 * We need Responsive images and css from this component.
 */
type LinkedTeaserImageTopHeadlines = {
  image: TopHeadlineImage | TopHeadlineImageSmall;
  pageLink?: string;
  fetchUrl: string;
  modifier?: 'no-grid';
};

export function LinkedTeaserImageTopHeadlines({ image, pageLink, fetchUrl, modifier }: LinkedTeaserImageTopHeadlines) {
  return (
    <div className={Bem('linked-teaser-image-in-lists', modifier)} aria-hidden>
      <Image
        image={image}
        emptyAltText // it only has an empty alt, when it is wrapped in an <a>!
        modifier={ImageModifier.CENTER_HORIZONTAL}
        hideAdjacentImageLink
        linkUrl={pageLink}
        responsiveType={
          image.imageType === 'topHeadlineImageSmall'
            ? RESPONSIVE_TYPE.topHeadlineImageSmall
            : RESPONSIVE_TYPE.topHeadlineImage
        }
        lazyLoading
        fetchUrl={fetchUrl}
      />
    </div>
  );
}
